import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "../../../../../reducers/initialState";
import { emptyArray } from "constants/emptyConst";

export default function insuranceReducer(state = initialState.currentOffer.insuranceData, action) {
  switch (action.type) {
    case actionTypes.LOAD_OFFER_INSURANCE_SUCCEEDED:
      return {
        ...state,
        insurance: action.payload,
        insuranceLoaded: true,
        productsLoaded: true
      };

    case actionTypes.LOAD_OFFER_INSURANCE_COMPANIES_SUCCEEDED:
      return {
        ...state,
        companies: action.payload,
        companiesLoaded: true
      };

    case eventTypes.OFFER_INSURANCE_INVALIDATED:
      return initialState.currentOffer.insuranceData;

    case actionTypes.LOAD_OFFER_INSURANCE_PRODUCTS_STARTED:
      return {
        ...state,
        products: emptyArray,
        productsLoaded: false
      };

    case actionTypes.LOAD_OFFER_INSURANCE_PRODUCTS_SUCCEEDED:
      return {
        ...state,
        products: action.payload.products,
        productsLoaded: true
      };

    case actionTypes.SAVE_OFFER_INSURANCE_STARTED:
      return {
        ...state,
        saving: true
      };

    case actionTypes.SAVE_OFFER_INSURANCE_SUCCEEDED:
      return {
        ...state,
        saving: false,
        insurance: { ...action.payload.insurance, isNew: false },
        products: null
      };

    case actionTypes.SAVE_OFFER_INSURANCE_FAILED:
      return {
        ...state,
        saving: false
      };

    case actionTypes.CANCEL_OFFER_INSURANCE_CHANGES:
      return {
        ...state,
        products: null
      };

    default:
      return state;
  }
}
